/** Popular supplier catalogue markets (alphabetical), matching preview flags. */
export const MARKETS = [
    { code: 'ar', name: 'Argentina' },
    { code: 'au', name: 'Australia' },
    { code: 'bd', name: 'Bangladesh' },
    { code: 'br', name: 'Brazil' },
    { code: 'ca', name: 'Canada' },
    { code: 'cl', name: 'Chile' },
    { code: 'co', name: 'Colombia' },
    { code: 'cz', name: 'Czech Republic' },
    { code: 'eg', name: 'Egypt' },
    { code: 'fr', name: 'France' },
    { code: 'de', name: 'Germany' },
    { code: 'gh', name: 'Ghana' },
    { code: 'hu', name: 'Hungary' },
    { code: 'in', name: 'India' },
    { code: 'id', name: 'Indonesia' },
    { code: 'it', name: 'Italy' },
    { code: 'jp', name: 'Japan' },
    { code: 'jo', name: 'Jordan' },
    { code: 'ke', name: 'Kenya' },
    { code: 'my', name: 'Malaysia' },
    { code: 'mx', name: 'Mexico' },
    { code: 'nl', name: 'Netherlands' },
    { code: 'ng', name: 'Nigeria' },
    { code: 'pk', name: 'Pakistan' },
    { code: 'pe', name: 'Peru' },
    { code: 'ph', name: 'Philippines' },
    { code: 'pl', name: 'Poland' },
    { code: 'ro', name: 'Romania' },
    { code: 'sa', name: 'Saudi Arabia' },
    { code: 'sg', name: 'Singapore' },
    { code: 'za', name: 'South Africa' },
    { code: 'es', name: 'Spain' },
    { code: 'lk', name: 'Sri Lanka' },
    { code: 'th', name: 'Thailand' },
    { code: 'tr', name: 'Türkiye' },
    { code: 'ua', name: 'Ukraine' },
    { code: 'ae', name: 'United Arab Emirates' },
    { code: 'gb', name: 'United Kingdom' },
    { code: 'us', name: 'United States' },
    { code: 'vn', name: 'Vietnam' },
];
